import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-sales-breadcrumbs',
  templateUrl: './sales-breadcrumbs.component.html'
})
export class SalesBreadcrumbsComponent {

  @Input({required: true}) routes: any[] = [];
  constructor() {}
}
